import { generateCSS } from 'Common/components/Form';
import inputStylesGenerator from '../Input/styles';

// Reuses the TextArea/Input look (border, font, label) and adds the toolbar.
const stylesGenerator = (theme, props) => {
  const inputStyles = inputStylesGenerator(theme, props);

  return {
    ...inputStyles,

    editor: generateCSS({
      // `height` from the `styles` prop becomes the minimum; the field grows
      // with pasted content (e.g. tables) and then scrolls
      minHeight: (props.styles && props.styles.height) || '100px',
      height: 'auto',
      maxHeight: '300px',
      overflow: 'auto',
      cursor: 'text',
      wordBreak: 'break-word',
      '& p': { margin: 0 },
      '& ul, & ol': { margin: 0, paddingLeft: '24px' },
      '& ul': { listStyleType: 'disc' },
      '& ol': { listStyleType: 'decimal' },
      '& li': { display: 'list-item' },
      '& ul ul': { listStyleType: 'circle' },
      '& ul ul ul': { listStyleType: 'square' },
      '& h1, & h2, & h3, & h4, & h5, & h6': {
        margin: 0,
        fontWeight: 'bold',
        color: 'inherit'
      },
      '& h1': { fontSize: '2em' },
      '& h2': { fontSize: '1.5em' },
      '& h3': { fontSize: '1.17em' },
      '& blockquote': {
        margin: '0 0 0 8px',
        paddingLeft: '8px',
        borderLeft: '3px solid #ccc'
      },
      '& pre': { margin: 0, fontFamily: 'monospace', whiteSpace: 'pre-wrap' },
      '& table': { borderCollapse: 'collapse', margin: '4px 0' },
      '& td, & th': { verticalAlign: 'top' },
      '& img': { maxWidth: '100%' },
      '& a': { color: '#0563c1', textDecoration: 'underline' },
      ':empty::before': {
        content: 'attr(data-placeholder)',
        color: theme.colors.quinary
      }
    }),

    toolbar: generateCSS({
      display: 'flex',
      flexWrap: 'wrap',
      border: `2px solid ${theme.colors.primary}`,
      borderBottom: 'none',
      padding: '2px'
    }),

    toolbarButton: generateCSS({
      minWidth: '28px',
      height: '24px',
      margin: '1px',
      padding: '0 6px',
      border: '1px solid transparent',
      background: 'none',
      color: theme.colors.primary,
      cursor: 'pointer',
      fontSize: '13px',
      ':hover': { borderColor: theme.colors.primary },
      '&.active': {
        borderColor: theme.colors.active,
        color: theme.colors.active
      },
      ':disabled': { opacity: 0.5, cursor: 'not-allowed' }
    })
  };
};

export default stylesGenerator;
